import { trimTrailingSlash } from '../utils/trim-trailing-slash';
import { RSS_ROUTE_TYPES } from './consts';
import { getBlogFeedRoute } from './get-verticals-rss-route';
import { SD_STATUS } from '../consts';
export var getRssTitle = function (siteName) { return "".concat(siteName, " - RSS"); };
export var getRssFullURL = function (_a) {
    var siteUrl = _a.siteUrl, rssRoute = _a.rssRoute;
    if (siteUrl) {
        return "".concat(trimTrailingSlash(siteUrl), "/").concat(rssRoute);
    }
    else {
        return '';
    }
};
export var getRssRoute = function (_a) {
    var _b = _a === void 0 ? {} : _a, rssRouteType = _b.rssRouteType, _c = _b.payload, payload = _c === void 0 ? {} : _c;
    switch (rssRouteType) {
        case RSS_ROUTE_TYPES.BLOG:
            var _d = payload.item, item = _d === void 0 ? {} : _d;
            return getBlogFeedRoute(item);
        default:
            break;
    }
};
export var getSchema = function (tags, schemaType) {
    return tags.filter(function (tag) {
        return tag.type === 'script' && JSON.parse(tag.children)['@type'] === schemaType;
    });
};
export var getItemsSdStatus = function (allItems, validItems) {
    if (validItems === '' || allItems.length === 0) {
        var hasItem = allItems.length > 0;
        if (hasItem) {
            return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
        }
        return SD_STATUS.DOES_NOT_EXIST;
    }
    return SD_STATUS.ENABLED;
};
